module.exports = __webpack_public_path__ + "static/bar-white-3bd94f45d80ff1cbe8fac7404483f44b.png";